<!-- gas-price-alert-viewer.component.html -->
<div class="rounded-xl border border-purple-400/50 p-4 shadow-md backdrop-blur-md bg-white/10 dark:bg-[#1e1e2f]/40 transition-all">

  <p [ngClass]="{
    'text-base font-medium tracking-wide text-black dark:text-blue-200': isArabicLang,
    'text-sm font-medium text-black dark:text-white': !isArabicLang
  }">
    ⛽ {{ 'BEING_ALERT_GAS_PRICE_CONDITION' | translate }}
    <strong class="text-purple-500">{{ alert.threshold | number:'1.2-2' }} {{ 'GWEI' | translate }}</strong>

    <img *ngIf="alert.chainId"
         [src]="CHAIN_MAP[alert.chainId]?.icon"
         [alt]="CHAIN_MAP[alert.chainId]?.name"
         class="inline-block w-4 h-4 align-text-bottom ml-1" />

    <span *ngIf="!alert.active"
          [ngClass]="{
            'text-sm text-yellow-500 ml-2': isArabicLang,
            'text-xs text-yellow-500 ml-2': !isArabicLang
          }">
      ({{ 'INACTIVE' | translate }})
    </span>
  </p>

  <!-- Actions -->
  <div class="flex items-center gap-3 mt-3">
    <button *ngIf="alert.triggered"
            (click)="reactivateAlert.emit(alert)"
            [ngClass]="{
              'text-sm text-blue-600 underline': isArabicLang,
              'text-xs text-blue-600 underline': !isArabicLang
            }">
      🔁 {{ 'REACTIVATE' | translate }}
    </button>

    <span class="text-sm text-blue-600 hover:text-blue-700 cursor-pointer ml-1 flex items-center"
          (click)="goToSwap.emit(alert)">
      <span class="mr-1">✨</span>
      <span class="underline font-semibold">Swap maintenant</span>
    </span>

    <button (click)="removeAlert.emit(alert)"
            [disabled]="isLoading"
            [ngClass]="{
              'text-sm text-red-600 underline': isArabicLang,
              'text-xs text-red-600 underline': !isArabicLang
            }">
      ❌ {{ 'DELETE' | translate }}
    </button>
  </div>
</div>
